import {
  Forsikringsselskab,
  TilsynsErklaering,
} from "../interfaces/tilsynserklaering";
import { get, put } from "./util";

export async function getTilsynsErklaeringer() {
  return get<TilsynsErklaering[]>({
    query: "Tilsynserklaering/HentTilsynserklaeringer",
  });
}
export async function getTilsynsErklaering(id: string) {
  return get<TilsynsErklaering>({
    query: "Tilsynserklaering/HentTilsynserklaering/" + id,
  });
}

export async function getForsikringsselskaber() {
  return get<Forsikringsselskab[]>({
    query: "Tilsynserklaering/HentForsikringsselskaber",
  });
}

export async function putTilsynsErklaering(
  erklering: Partial<TilsynsErklaering>,
) {
  return put<TilsynsErklaering[]>({
    query: "Tilsynserklaering",
    body: erklering,
  });
}
